import React from 'react';
const ProductStory = () => {
  return <div className="mb-12" data-id="element-152">
      <div className="flex justify-center mb-8" data-id="element-153">
        <div className="w-full max-w-md h-auto overflow-hidden rounded-lg shadow-lg" data-id="element-154">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rSZqmt5758LAL71pFfqfPs/7ad8b5ab-80a4-4bf7-b530-5679ff5e46f6.png" alt="Person holding knee in pain with inflammation highlighted in red" className="w-full object-cover object-top" style={{
          aspectRatio: '4/3'
        }} data-id="element-155" />
        </div>
      </div>
      <div className="prose prose-xl max-w-none" data-id="element-156">
        <p className="mb-5 text-xl" data-id="element-157">Susan had already tried everything:</p>
        <ul className="list-disc pl-8 space-y-3 mb-8 text-xl" data-id="element-158">
          <li className="pl-2" data-id="element-159">NSAIDs that destroyed her stomach</li>
          <li className="pl-2" data-id="element-160">Prescription painkillers that left her foggy</li>
          <li className="pl-2" data-id="element-161">$500 cortisone shots that lasted 3 weeks</li>
          <li className="pl-2" data-id="element-162">Physical therapy that made things worse</li>
          <li className="pl-2" data-id="element-163">Every cream and brace at the drugstore</li>
        </ul>
        <div className="flex justify-center mb-8" data-id="element-164">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i6Pa7dzKLTauXHUEcJBD4z/Untitled_design_%287%29.png" alt="Pills and medications with red X - ineffective treatments" className="w-full max-w-md h-auto rounded-lg shadow-md" data-id="element-165" />
        </div>
        <p className="mb-8 text-xl leading-relaxed" data-id="element-166">
          Nothing worked. Until she discovered something at a local farmer's
          market that changed everything.
        </p>
      </div>
      <div id="discovery" className="scroll-mt-16" data-id="element-167">
        <h2 className="text-4xl font-bold text-green-600 mb-6 relative inline-block" data-id="element-168">
          The Discovery That Changed Everything
          <span className="absolute -bottom-1 left-0 right-0 h-1 bg-green-200" data-id="element-169"></span>
        </h2>
        <div className="prose prose-xl max-w-none" data-id="element-170">
          <p className="mb-5 text-xl leading-relaxed" data-id="element-171">
            Dr. Mei was explaining Traditional Chinese Medicine principles at
            her booth. Susan almost walked by – she'd tried "natural" remedies
            before.
          </p>
          <p className="mb-5 text-xl leading-relaxed" data-id="element-172">
            But then Dr. Mei said something that stopped her cold:
          </p>
          <blockquote className="border-l-4 border-green-500 pl-6 py-4 my-8 bg-green-50 rounded-r-lg" data-id="element-173">
            <p className="font-bold italic text-2xl text-gray-800 leading-relaxed" data-id="element-174">
              "Pills only get 3% of their active ingredient to your knee joint.
              The rest floods your body causing side effects. Creams sit on your
              skin surface. But what if you could deliver healing herbs DIRECTLY
              into the joint tissue?"
            </p>
          </blockquote>
        </div>
        <div className="my-10 flex flex-col md:flex-row gap-10" data-id="element-175">
          <div className="md:w-3/5" data-id="element-176">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k1sRtyQn6Uuv6Zvj95uonL/39facd5d-0ee8-4cd5-9031-95ff1cd10e0c.png" alt="Dr. Mei in her Traditional Medicine shop" className="w-full h-auto rounded-lg shadow-md" style={{
            maxHeight: '500px',
            objectFit: 'cover'
          }} data-id="element-177" />
          </div>
          <div className="md:w-2/5" data-id="element-178">
            <div className="prose prose-xl max-w-none" data-id="element-179">
              <p className="mb-5 text-xl leading-relaxed" data-id="element-180">
                Dr. Mei introduced Susan to MyoQuell patches, which combine
                ancient Chinese herbs with a modern delivery system. She
                explained how these patches had helped many of her clients find
                relief, including her own mother who had suffered through two
                failed knee surgeries.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-10 mb-2 flex flex-col md:flex-row gap-8" data-id="element-181">
          <div className="md:w-3/5" data-id="element-182">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5CzvRbrXpnBDu8veXrQnBA/Untitled_design_%2860%29.png" alt="MyoQuell Herbal Knee Patches package and applied patch" className="w-full h-auto rounded-lg shadow-md" style={{
            maxHeight: '500px',
            objectFit: 'cover'
          }} data-id="element-183" />
          </div>
          <div className="md:w-2/5" data-id="element-184">
            <p className="text-xl leading-relaxed" data-id="element-185">
              The patch contains a <strong data-id="element-186">proprietary blend</strong> of{' '}
              <strong data-id="element-187">five powerful herbs</strong> that have been used in{' '}
              <strong data-id="element-188">Traditional Chinese Medicine</strong> for{' '}
              <strong data-id="element-189">centuries</strong> to <strong data-id="element-190">relieve pain</strong> and{' '}
              <strong data-id="element-191">reduce inflammation</strong>.
            </p>
          </div>
        </div>
        <p className="text-xl leading-relaxed" data-id="element-192">
          What makes MyoQuell different is the{' '}
          <strong data-id="element-193">advanced delivery system</strong> that helps these herbs{' '}
          <strong data-id="element-194">penetrate deep</strong> into the joint tissue, where they can
          work <strong data-id="element-195">directly at the source of pain</strong>.
        </p>
        <div className="flex justify-center mb-8" data-id="element-196">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e2LwoKr9pjU1q3dLESfg9C/9fbe539d-7a0a-441e-84b4-140e9bad7fc0.png" alt="MyoQuell patch with white and green sides" className="w-full max-w-sm h-auto rounded-lg shadow-md" data-id="element-197" />
        </div>
        <div className="my-10 bg-green-50 border-2 border-green-200 p-6 rounded-lg shadow-md" data-id="element-198">
          <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white w-full py-4 rounded-lg font-bold block text-center transition-colors shadow-lg text-xl" target="_blank" rel="noopener noreferrer" data-id="element-199">
            TRY MYOQUELL RISK-FREE TODAY →
          </a>
          <p className="text-center text-sm mt-4 text-gray-600" data-id="element-200">
            <span className="inline-flex items-center" data-id="element-201">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-2" viewBox="0 0 20 20" fill="currentColor" data-id="element-202">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-203" />
              </svg>
              30-Day Money Back Guarantee
            </span>
          </p>
        </div>
        <h2 className="text-4xl font-bold text-green-600 mb-5" data-id="element-204">
          Why Nothing Else Works
        </h2>
        <div className="mb-6" data-id="element-205">
          <h3 className="font-bold mb-3 text-2xl" data-id="element-206">The Problem:</h3>
          <p className="text-xl leading-relaxed" data-id="element-207">
            Your knee pain comes from inflammation deep in the joint tissue,
            plus pain signals that won't stop firing.
          </p>
        </div>
        <div className="mb-6" data-id="element-208">
          <h3 className="font-bold mb-3 text-2xl" data-id="element-209">Why Pills Fail:</h3>
          <p className="text-xl leading-relaxed" data-id="element-210">
            They travel through your entire digestive system. By the time they
            reach your knees, you've got a belly full of chemicals and barely
            any relief.
          </p>
        </div>
        <div className="mb-6" data-id="element-211">
          <h3 className="font-bold mb-3 text-2xl" data-id="element-212">Why Creams Fail:</h3>
          <p className="text-xl leading-relaxed" data-id="element-213">
            They can't penetrate past your skin surface. That cooling sensation?
            It's just masking pain, not fixing it.
          </p>
        </div>
        <div className="my-10" id="ingredients" data-id="element-214">
          <div className="flex justify-center mb-8" data-id="element-215">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1zvEet3naUkzRpLijRiwpW/Green_and_Beige_Retro_Vintage_Natural_Product_Badge_Logo_%283%29.png" alt="MyoQuell green herbal patches being applied to knees" className="w-full rounded-lg shadow-md" data-id="element-216" />
          </div>
          <h3 className="text-3xl font-bold mb-4" data-id="element-217">
            The 4,000-Year-Old Solution
          </h3>
          <p className="mb-4 text-xl leading-relaxed" data-id="element-218">
            MyoQuell patches contain five powerful herbs that work together:
          </p>
          <ul className="space-y-6 mb-6 text-xl" data-id="element-219">
            <li className="flex items-center transform transition-transform hover:scale-[1.01]" data-id="element-220">
              <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0 border-2 border-green-500" data-id="element-221">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iKSwDBCvGEgqndZpEqoykJ/Copy_of_Copy_of_Untitled_%281%29.png" alt="Artemisia Argyi herb" className="w-full h-full object-cover" data-id="element-222" />
              </div>
              <span className="leading-relaxed" data-id="element-223">
                <strong data-id="element-224">Artemisia Argyi:</strong> Reduces inflammation at the
                cellular level
              </span>
            </li>
            <li className="flex items-center transform transition-transform hover:scale-[1.01]" data-id="element-225">
              <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0 border-2 border-green-500" data-id="element-226">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6xnVYAEPcKgEq3kVxGryzM/Copy_of_Copy_of_Untitled_%282%29.png" alt="Radix Aconiti herb" className="w-full h-full object-cover" data-id="element-227" />
              </div>
              <span className="leading-relaxed" data-id="element-228">
                <strong data-id="element-229">Radix Aconiti:</strong> Nature's pain signal blocker
              </span>
            </li>
            <li className="flex items-center transform transition-transform hover:scale-[1.01]" data-id="element-230">
              <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0 border-2 border-green-500" data-id="element-231">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inQUUKin7eo7V7Jn7G7ncN/Copy_of_Copy_of_Untitled.png" alt="Capsaicin pepper" className="w-full h-full object-cover" data-id="element-232" />
              </div>
              <span className="leading-relaxed" data-id="element-233">
                <strong data-id="element-234">Capsaicin:</strong> Depletes Substance P (the pain
                messenger) by up to 50%
              </span>
            </li>
            <li className="flex items-center transform transition-transform hover:scale-[1.01]" data-id="element-235">
              <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0 border-2 border-green-500" data-id="element-236">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pqcXcFnJo1No2uGhc15RSo/Copy_of_Copy_of_Untitled_%283%29.png" alt="Ginger Root" className="w-full h-full object-cover" data-id="element-237" />
              </div>
              <span className="leading-relaxed" data-id="element-238">
                <strong data-id="element-239">Ginger Root:</strong> Increases circulation and fights
                inflammation
              </span>
            </li>
            <li className="flex items-center transform transition-transform hover:scale-[1.01]" data-id="element-240">
              <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0 border-2 border-green-500" data-id="element-241">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jsPcV5JVY5EyuRhhXmxhFS/Copy_of_Copy_of_Untitled_%284%29.png" alt="Menthol leaves" className="w-full h-full object-cover" data-id="element-242" />
              </div>
              <span className="leading-relaxed" data-id="element-243">
                <strong data-id="element-244">Menthol & Camphor:</strong> Immediate relief while other
                herbs work
              </span>
            </li>
          </ul>
          <p className="mt-5 text-xl leading-relaxed" data-id="element-245">
            The Breakthrough: Two penetration enhancers – Azone and Borneol –
            act like a "delivery system" that carries these herbs deep into your
            joint tissue. No pill or cream can do this.
          </p>
          <p className="mt-4 text-xl leading-relaxed" data-id="element-246">
            The herbs then release slowly over 8-12 hours. One patch. All-day
            relief.
          </p>
        </div>
        <div className="flex justify-center my-10" data-id="element-247">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xaJ2Yegah1vTFJe4xXTFAX/Untitled_design_%2859%29.png" alt="MyoQuell Herbal Knee Pain Relief Patches" className="w-full max-w-md h-auto rounded-lg shadow-md" data-id="element-248" />
        </div>
        <div className="my-10" data-id="element-249">
          <h3 className="text-3xl font-bold mb-4" data-id="element-250">Susan's Transformation</h3>
          <p className="mb-4 text-xl leading-relaxed" data-id="element-251">
            That night, Susan tried her first patch.
          </p>
          <p className="mb-4 italic text-xl leading-relaxed" data-id="element-252">
            "I woke up at 6:30 and realized I'd slept through the entire night.
            First time in three years."
          </p>
          <p className="mb-4 text-xl leading-relaxed" data-id="element-253">
            But the real test came when she stood up.
          </p>
          <p className="mb-4 italic text-xl leading-relaxed" data-id="element-254">
            "I waited for that stabbing pain. It never came."
          </p>
          <ul className="list-disc pl-8 space-y-3 text-xl mb-5" data-id="element-255">
            <li className="leading-relaxed" data-id="element-256">
              Week 1: Walking stairs without gripping the railing
            </li>
            <li className="leading-relaxed" data-id="element-257">Week 2: Back in her garden</li>
            <li className="leading-relaxed" data-id="element-258">
              Week 4: Dancing at her niece's wedding
            </li>
          </ul>
          <p className="mt-5 italic text-xl leading-relaxed" data-id="element-259">
            "Emma looked at me and said, 'Grandma, you're fun again!' I just
            about cried right there on the dance floor."
          </p>
        </div>
      </div>
    </div>;
};
export default ProductStory;